


























































































import { Component } from "vue-property-decorator";
import Header from "@/components/header/MLoginHeader.vue";
import Footer from "@/components/Footer.vue";
import UsersApi from "@/services/UsersApi";
import MaterialGroupApi from "@/services/MaterialGroups";
import { UGCType, User } from "@/api/lab-base-api-client";
import CheckAdminLogin from "@/utils/CheckAdminLogin";
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";

@Component({
  components: {
    Header,
    Footer,
  },
})
export default class MUserListDetail extends CheckAdminLogin {
  private user: User = {
    uuid: "",
    name: "",
    email: "",
    userDetailUuid: "",
    roleId: 0,
    ugcUuid: "",
    lastLoginAt: "",
    createdAt: "",
    updatedAt: "",
    deleted: false,
    registered: false,
    paidFlag: false,
    cusId: "",
    userDetail: {
      uuid: "",
      fullName: "",
      birthday: "",
      postalCode: "",
      prefecture: "",
      city: "",
      addressLine1: "",
      addressLine2: "",
      phoneNumber: "",
    },
    role: {
      id: 0,
      name: "",
    },
    ugc: {
      deleted: false,
      ugcType: UGCType.Image,
      url: "",
      thumbnailUrl: "",
      metadata: {
        filename: "",
        originalname: "",
        encoding: "",
        mimetype: "",
        fieldname: "",
        destination: "",
        path: "",
        size: 0,
      },
      hashSHA256: "",
      createdAt: "",
      updatedAt: "",
      uuid: "",
    },
  };

  // 教材の完了パーセンテージ
  private percentage = 0;

  private userInfo = { birthday: "", updatedAt: { day: "", ago: "" }, register: { day: "", ago: "" } };

  // ページ読み込み時に実行
  private async mounted() {
    dayjs.extend(relativeTime);

    await this.fetchList();
    await this.calcPercentage();
  }

  // ユーザー情報の取得
  private async fetchList() {
    const userRes = await UsersApi.instance.getUserByUuid(this.$route.params.uuid);
    this.user = userRes.data.data.user;
    this.userInfo.birthday = dayjs(this.user.userDetail.birthday).format("YYYY/MM/DD");
    this.userInfo.updatedAt.day = dayjs(this.user.lastLoginAt).format("YYYY/MM/DD");
    this.userInfo.updatedAt.ago = dayjs(this.user.lastLoginAt).fromNow();
    this.userInfo.register.day = dayjs(this.user.createdAt).format("YYYY/MM/DD");
    this.userInfo.register.ago = dayjs(this.user.createdAt).fromNow();
  }

  private async calcPercentage() {
    const materialGroupsRes = await MaterialGroupApi.instance.getMaterialGroup();
    const materialGroups = materialGroupsRes.data.data.items;

    const userDetailMaterialGroups = await UsersApi.instance.getCompleteMaterialGroupByUserDetailUuid(
      this.user?.userDetailUuid
    );
    this.percentage = Math.floor(
      (userDetailMaterialGroups.data.data.completeMaterialGroup.items.length / materialGroups.length) * 100
    );
  }
}
